import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { fetchWrapper, getUserTimeZone } from '../../helpers'
import { Box, Tag, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Spinner } from '@chakra-ui/react'
import Pagination from 'react-js-pagination'

const Transaction = ({ id }) => {
    const [listTrans, setListTrans] = useState([])
    const [activePage, setActivePage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);
    const [loading, setLoading] = useState(false);

    const onChangePaginate = (pageNumber) => {
        setActivePage(pageNumber);
    };

    useEffect(() => {
        loadTrans(activePage);
    }, [activePage, id]);

    const loadTrans = async (page = 1) => {
        setLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URL}/transaction/list?customer_id=${id}&page=${page}&limit=${itemsPerPage}`;
            const data = await fetchWrapper.get(url);
            setListTrans(data);
        } catch (error) {
            console.error("Error loading transactions:", error);
        } finally {
            setLoading(false);
        }
    };

    const rows = listTrans?.data || [];

    return (
        <Box>
            <Box mb={3}>
                <Text fontSize="sm" fontWeight="bold" mb={1}>Transaction History</Text>
                <Text color="gray.600" fontSize="xs">Balance top-ups and message spend for this customer</Text>
            </Box>

            <div className="table_section">
                <TableContainer width="100%">
                    <Table variant='simple' width="100%">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Message Id</Th>
                                <Th>Channel</Th>
                                <Th>Type</Th>
                                <Th isNumeric>Amount</Th>
                            </Tr>
                        </Thead>

                        <Tbody fontSize="14px">
                            {loading ? (
                                <Tr>
                                    <Td colSpan={5}>
                                        <Flex justify="center" align="center" py={6}>
                                            <Spinner size="md" color="blue.500" />
                                        </Flex>
                                    </Td>
                                </Tr>
                            ) : rows.length === 0 ? (
                                <Tr>
                                    <Td colSpan={5}>
                                        <Flex justify="center" py={6}>
                                            <Text color="gray.500" fontSize="sm">No transactions found.</Text>
                                        </Flex>
                                    </Td>
                                </Tr>
                            ) : (
                                rows.map((rs, index) => (
                                    <Tr key={rs?.id || index}>
                                        <Td color="gray.600">{moment.utc(rs.created_at).tz(getUserTimeZone()).format('DD/MM/YY')}</Td>
                                        <Td color="gray.500" fontSize="13px">{rs.message_id}</Td>
                                        <Td>
                                            <Tag colorScheme="gray" borderRadius="4px" px={2} py="2px" fontWeight="500" fontSize="11px" textTransform="capitalize">
                                                {rs.channel}
                                            </Tag>
                                        </Td>
                                        <Td>
                                            <Tag colorScheme={rs.trans_type === "CR" ? "green" : "red"} borderRadius="4px" px={2} py="2px" fontWeight="600" fontSize="11px">
                                                {rs.trans_type === "CR" ? "Credit" : "Debit"}
                                            </Tag>
                                        </Td>
                                        <Td isNumeric fontWeight="600" color="#111827">
                                            {rs.currency} {rs.amount}
                                        </Td>
                                    </Tr>
                                ))
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>

                {rows.length > 0 && (
                    <Flex justifyContent="center" alignItems="center" my={4}>
                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={itemsPerPage}
                            totalItemsCount={listTrans.count || 0}
                            pageRangeDisplayed={5}
                            onChange={onChangePaginate}
                            innerClass="pagination"
                            itemClass="page-item"
                            activeLinkClass="page-link active"
                            linkClass="page-link"
                            prevPageText="Previous"
                            nextPageText="Next"
                        />
                    </Flex>
                )}
            </div>
        </Box>
    )
}

export default Transaction